module.exports = __webpack_public_path__ + "img/empty_data.8ca72dd5.png";